import { addHours, differenceInSeconds, endOfHour, startOfHour, subHours } from 'date-fns';
import { useMemo } from 'react';

import { useStableValue } from '@/hooks/useStableValue';
import { useTzContext } from '@/hooks/useTzContext';
import { DateRange } from '@/store/types';

// TODO: Look at callers of this and pass meaningful sampleRateMinutes
// https://app.shortcut.com/sofar/story/284300/clean-up-sampling-windows-post-bluetide
export const useDateRangeForSample = (
    targetTime: Date | string | number | undefined | null,
    sampleRateMinutes: number = 30
): DateRange | null => {
    const tz = useTzContext();
    return useStableValue(
        useMemo(() => {
            if (!targetTime) {
                return null;
            }
            // pick a window with round hour boundaries since useLiveSplitQueries is going to expand it out at least that far anyway.
            // if we're within sampleRateMinutes of the edge, go one hour further in case our closest sample is over the line.
            const dateRange = { startDate: startOfHour(targetTime, tz), endDate: endOfHour(targetTime, tz) };
            if (differenceInSeconds(targetTime, dateRange.startDate) < sampleRateMinutes * 60) {
                dateRange.startDate = subHours(dateRange.startDate, 1);
            }
            if (differenceInSeconds(dateRange.endDate, targetTime) < sampleRateMinutes * 60) {
                dateRange.endDate = addHours(dateRange.endDate, 1);
            }
            return dateRange;
        }, [targetTime, sampleRateMinutes, tz])
    );
};
